export enum AdminMultimediaLibraryAction {
  Upload,
}
